import { env } from "@/env.mjs";
import { RepositoryHttp } from "@/infrastructure/repositories/http";
import { UseCases } from "@/use-cases";

export const useBackend = (sessionToken?: string) => {
  const repository = new RepositoryHttp(
    env.NEXT_PUBLIC_HARPIO_BACKEND_URL,
    sessionToken,
  );

  const getAIDescriptionByCargoId =
    new UseCases.jobOpening.getAIDescriptionByCargoId(repository).run;

  const getMyVacancyById = new UseCases.vacancies.getMyVacancyById(repository)
    .run;

  const getMyVacancies = new UseCases.vacancies.getMyVacancies(repository).run;

  const getCandidateByJob = new UseCases.candidate.getCandidateByJob(repository)
    .run;

  const getJobById = new UseCases.jobs.getJobById(repository).run;
  const getMyJobs = new UseCases.jobs.getMyJobs(repository).run;

  const getCountJobs = new UseCases.jobs.getJobsCount(repository).run;
  const getJobHistoryInputFilter = new UseCases.jobs.getInputByJobHistory(
    repository,
  ).run;

  const getJobHistoryFiltered = new UseCases.jobs.getJobHistoryFiltered(
    repository,
  ).run;

  const getMetricsByJobId = new UseCases.vacancies.metrics.getMetricsByJobId(
    repository,
  ).run;

  const getStatistics = new UseCases.statistics.getStatistics(repository).run;

  const getJobTalentStatistics = new UseCases.statistics.getJobTalentStatistics(
    repository,
  ).run;

  const getJobHireStatistics = new UseCases.statistics.getJobHireStatistics(
    repository,
  ).run;

  const getShortlistByJobId = new UseCases.shortlist.getByJobId(repository).run;
  const getNewShortlistByJobId = new UseCases.shortlist.getNewByJobId(
    repository,
  ).run;

  const getSkillsByTalentId =
    new UseCases.shortlist.profile.talent.getSkillsByTalentId(repository).run;

  const getExperienceByTalentId =
    new UseCases.shortlist.profile.talent.getExperienceByTalentId(repository)
      .run;

  const getProfile = new UseCases.profile.getProfile(repository).run;

  const passwordRegistration = new UseCases.user.passwordRegistration(
    repository,
  ).run;

  const socialRegistration = new UseCases.user.socialRegistration(repository)
    .run;

  const getShortlistTalentEducationById =
    new UseCases.shortlist.profile.talent.getEducationById(repository).run;

  const getShortlistTalentProfileSummaryByTalentId =
    new UseCases.shortlist.profile.talent.getSummaryByTalentId(repository).run;

  const postJobNPS = new UseCases.npsVagas.postJobNPS(repository).run;
  const postHireNewTalent = new UseCases.push.postHireNewTalent(repository).run;
  const postCandidateByJob = new UseCases.push.postCandidateByJob(repository)
    .run;

  const postCandidateSprintByJob =
    new UseCases.sprint.talent.postCandidateByJob(repository).run;

  const getPanoramaDadosArea = new UseCases.panorama.getPanoramaDadosArea(
    repository,
  ).run;

  const getPanoramaProfessionalProfile =
    new UseCases.panorama.getProfessionalProfileByJobId(repository).run;

  const getPanoramaAboutPosition =
    new UseCases.panorama.aboutPosition.getAboutPositionByJobId(repository).run;

  const getPanoramaAverageWage = new UseCases.panorama.getAverageWageByJobId(
    repository,
  ).run;

  const getSprintHomePage = new UseCases.sprint.getHomePage(repository).run;

  const solicitarEntrevista = new UseCases.sprint.solicitarEntrevista(
    repository,
  ).run;

  const getPublicShortlist = new UseCases.shortlist.public.getPublicShortlist(
    repository,
  ).run;

  const getPublicTalentsOfShortlist =
    new UseCases.shortlist.public.getTalentsOfShortlist(repository).run;
  const getSprintByTalentId = new UseCases.sprint.talent.getById(repository)
    .run;

  const getPanoramaCargoByName = new UseCases.panorama.getPanoramaCargoByName(
    repository,
  ).run;

  const getJobOpeningPanoramaById = new UseCases.jobOpening.getPanoramaById(
    repository,
  ).run;

  const getJobOpeningFiltersInputData =
    new UseCases.jobOpening.getFiltersInputData(repository).run;

  const postSendJobOpening = new UseCases.jobOpening.postSendJobOpening(
    repository,
  ).run;

  const postTalkToSpecialist = new UseCases.jobOpening.postTalkToSpecialist(
    repository,
  ).run;

  const postLeadOpeningJob = new UseCases.jobOpening.postLeadOpeningJob().run;

  const postTalentLike = new UseCases.shortlist.talent.postLikeTalent(
    repository,
  ).run;

  const postReportCreateIssue = new UseCases.report.createIssue(repository).run;
  const getFinishedJobById = new UseCases.jobs.getFinishedJobById(repository)
    .run;
  const getPushJobsList = new UseCases.jobs.getPushJobsList(repository).run;
  const getTalentProfileData = new UseCases.talent.getTalentProfileData(
    repository,
  ).run;
  const postTalentProfileData = new UseCases.talent.postTalentProfileData(
    repository,
  ).run;

  return {
    getSprintHomePage,
    getPublicShortlist,
    postTalentLike,
    getJobById,
    getPublicTalentsOfShortlist,
    getMyVacancies,
    getMyJobs,
    getCountJobs,
    getJobTalentStatistics,
    getJobHireStatistics,
    getMyVacancyById,
    getStatistics,
    getProfile,
    passwordRegistration,
    socialRegistration,
    getShortlistByJobId,
    getNewShortlistByJobId,
    getShortlistTalentProfileSummaryByTalentId,
    getShortlistTalentEducationById,
    getExperienceByTalentId,
    getSkillsByTalentId,
    getMetricsByJobId,
    postJobNPS,
    postHireNewTalent,
    getPanoramaDadosArea,
    getPanoramaProfessionalProfile,
    getPanoramaAboutPosition,
    getPanoramaAverageWage,
    getSprintByTalentId,
    solicitarEntrevista,
    getPanoramaCargoByName,
    getJobOpeningPanoramaById,
    getJobOpeningFiltersInputData,
    getAIDescriptionByCargoId,
    postSendJobOpening,
    postTalkToSpecialist,
    postLeadOpeningJob,
    getJobHistoryInputFilter,
    postReportCreateIssue,
    getFinishedJobById,
    getJobHistoryFiltered,
    getCandidateByJob,
    postCandidateByJob,
    postCandidateSprintByJob,
    getPushJobsList,
    getTalentProfileData,
    postTalentProfileData,
  };
};
